module.exports = __webpack_public_path__ + "static/avanti-a06ad56bba4695ba2efea184c60c618d.png";